module.exports = __webpack_public_path__ + "static/media/universal-app-montage.e7f55535.png";